import React from "react";
import novehicledataimg from "../../images/novehicledataimg.png";

const NoVehicleData = ({ text = "No Vehicle Entries Added" }) => {

  return (
    <div className=" flex items-center justify-center flex-col gap-2">
      <img className="" src={novehicledataimg} />
      <h3 className=" text-[30px] font-medium text-[#d4d4d2]">{text}</h3>
    </div>
  );
};

export default NoVehicleData;
